import { render, staticRenderFns } from "./addPlayer.vue?vue&type=template&id=4b0c347a&scoped=true&"
import script from "./addPlayer.vue?vue&type=script&lang=js&"
export * from "./addPlayer.vue?vue&type=script&lang=js&"
import style0 from "./addPlayer.vue?vue&type=style&index=0&id=4b0c347a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0c347a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b0c347a')) {
      api.createRecord('4b0c347a', component.options)
    } else {
      api.reload('4b0c347a', component.options)
    }
    module.hot.accept("./addPlayer.vue?vue&type=template&id=4b0c347a&scoped=true&", function () {
      api.rerender('4b0c347a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmToolNew/anchorMarketConfiguration/components/addPlayer.vue"
export default component.exports